export enum TestId {
  SELECTED_PC_FEEDBACK_PANEL = 'selected-pc-feedback-panel',
  PC_PENDING_FEEDBACK_LIST = 'pc-pending-feedback-list',
  PC_PENDING_FEEDBACK_LIST_SELECTED = 'pc-pending-feedback-list-selected',
  PC_PENDING_FEEDBACK_LIST_ITEM = 'pc-pending-feedback-list-item',
  PC_PENDING_FEEDBACK_LIST_ITEM_SELECTED = 'pc-pending-feedback-list-item-selected',
  PC_FEEDBACK_RUBRICS = 'pc-feedback-rubrics',
  PC_FEEDBACK_RUBRICS_LOADER = 'pc-feedback-rubrics-loader',
  PROFILE_CARD = 'profile-card',
}
